export default "/images/footerfoto.jpg?2dbb4d6fdb883ab660df7c9c16fd9134";